<div class="header">
  <div class="main-container">
    <nav class="navbar navbar-expand-lg navbar-light">
      <a [routerLink]="'/'" class="navbar-brand logo-holder image-holder full-image"><img
        src="assets/images/logos/logo.png"></a>

      <button aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
              class="navbar-toggler"
              data-target="#navbarSupportedContent" data-toggle="collapse" type="button">
        <span class="navbar-toggler-icon"></span>
      </button>


      <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">

<!--        <div class="last-block">-->
<!--          <div class="lang-toggle">-->
<!--            <button (click)="changeLang('ar')" [ngClass]="{'active': currentLang == 'ar'}" class="btn">Ar</button>-->
<!--            <button (click)="changeLang('en')" [ngClass]="{'active': currentLang == 'en'}" class="btn">En</button>-->
<!--          </div>-->

<!--        </div>-->

      </div>


    </nav>


  </div>
</div>


